import { EntityTablePage } from "@crispico/foundation-react";
import { IAction, IActionParamForRun } from "@crispico/react-timeline-10000/types/components/ContextMenu/IAction";
import { GanttUtils } from "pages/gantt/GanttUtils";
import React from "react";

export type AbstractActionProps = {
    getEntityUid: (key: string | number) => string,
    getEntityAt: (key: string | number) => { id: any; [key: string]: any; } | undefined,
    tablePage: EntityTablePage
};

export type AbstractActionLocalState = {};

/**
 * A base class for defining actions that can be triggered within a component.
 *
 * This abstract class serves as the foundation for creating two types of actions:
 * those with a user interface (UI), such as a modal, and those that perform an
 * action without a UI. 
 * Its design provides a consistent interface for managing both types of actions.
 *
 */
export abstract class AbstractAction<P extends AbstractActionProps = AbstractActionProps, S extends AbstractActionLocalState = AbstractActionLocalState> extends React.Component<P, S> implements IAction {

    constructor(props: P) {
        super(props);
        this.run = this.run.bind(this);
    }

    getEntityName(key: string | number) {
        return GanttUtils.fromEntityUid(this.props.getEntityUid(key)).entityName;
    }

    async run(param: IActionParamForRun) {
        throw Error("Needs to be implemented!");
    }

    render() {
        return <></>;
    }
}

type ContextMenuAction<P extends AbstractActionProps = AbstractActionProps> = React.ComponentClass<P>;

/**
 * Use this map to store the actions. e.g. `contextMenuActions.push(ExampleAction);`
 */
export const contextMenuActions: ContextMenuAction<AbstractActionProps>[] = [];

export type ContextMenuActionsProviderProps = {} & AbstractActionProps;
export class ContextMenuActionsProvider extends React.Component<ContextMenuActionsProviderProps> {

    protected actionRefs: { [key: string]: AbstractAction };

    constructor(props: ContextMenuActionsProviderProps) {
        super(props);
        this.actionRefs = {};
    }

    getActions(): AbstractAction[] {
        return Object.values(this.actionRefs);
    }

    componentWillUnmount() {
        this.actionRefs = {};
    }

    render() {
        {/* not sure if this "none" is needed, but wanted to be sure it will not add an empty div in UI */ }
        return <div style={{ display: "none" }}>
            {contextMenuActions.map((ActionComponent, index) => (
                <ActionComponent
                    key={`${ActionComponent.name}_${index}`}
                    ref={(el: AbstractAction) => this.actionRefs[ActionComponent.name] = el}
                    {...this.props}
                />
            ))}
        </div>
    }
}
